module.exports = __webpack_public_path__ + "static/media/standup.e0323265.mp4";